import useAuth from '@/hooks/use-auth/use-auth';
import {selectUserSettingsData} from '@/redux/reducers/userSettingsReducer';
import {useSelector} from 'react-redux';
import {sharedNavigationMap} from './content';

import DesktopNavigation from './Desktop/DesktopNavigation';
import MobileNavigation from './Mobile/MobileNavigation';
import {StyledNavigation} from './styles';
import {LinkProps} from './typings';

const Navigation = ({editorsPicks}) => {
  const userSettings = useSelector(selectUserSettingsData);
  const auth = useAuth();
  const sharedNavigation: LinkProps[] = sharedNavigationMap(
    editorsPicks,
    userSettings.currency_symbol,
  );

  return (
    <>
      <h2 className="sr-only">Main Navigation</h2>
      <MobileNavigation
        sharedNavigation={sharedNavigation}
        auth={auth}
        userSettings={userSettings}
      />
      <StyledNavigation>
        <DesktopNavigation
          sharedNavigation={sharedNavigation}
          userSettings={userSettings}
          auth={auth}
        />
      </StyledNavigation>
    </>
  );
};

export default Navigation;
